/**
 * Pushes data into the dataLayer and thus to Google Tag Manager.
 *
 * @param {*} event
 * @param {*} category
 * @param {*} action
 * @param {*} label
 * @param {*} value
 */
export function sendAnalyticsEvent(category, action, label, value) {
  let dataLayer = window.dataLayer || []
  if (typeof dataLayer === 'undefined') {
    return
  }
  const data = {
    event: 'kaffeemaschinenberater2.0',
    eventCategory: category,
    eventAction: action,
    eventLabel: label
  }

  const data2 = {
    event: 'conversionGoal',
    eventCategory: 'kaffeemaschinenberater2.0 - ' + category,
    eventAction: action,
    eventLabel: label
  }
  if (value !== undefined && value !== null) {
    data['eventValue'] = value
  }
  dataLayer.push(data)
  dataLayer.push(data2)
}

/**
 * Pushes data a virtual page into the dataLayer and thus to Google Tag Manager.
 *
 * @param {String} url
 * @param {String} title
 */
export function sendAnalyticsVirtualPageView(url, title) {
  let dataLayer = window.dataLayer || []
  if (typeof dataLayer === 'undefined') {
    return
  }
  const data = {
    event: 'VirtualPageview',
    virtualPageURL: document.location.pathname + url,
    virtualPageTitle: title
  }
  dataLayer.push(data)
}
